//@ts-ignore
import Formsy from 'formsy-react';

export type FormInvalidator = (fields: { [key: string]: string }) => void;

// This is the place you should write custom validators
Formsy.addValidationRule('isNotLength', function(_: any, value: string, array: number[]) {
  if (!value) {
    return array[0] >= 0;
  }

  if (value.length >= array[0] && value.length <= array[1]) {
    return false;
  }

  return true;
});

Formsy.customValidators = {};

Formsy.customValidators.isRequired = function(_: any, value: string | null | undefined) {
  return value === null || value === undefined || value === '';
};

Formsy.customValidators.isGreaterThan = function(_: any, value: number, min: number) {
  return Number(value) > min;
};

Formsy.customValidators.isLessThan = function(_: any, value: number, max: number) {
  return Number(value) < max;
};

Formsy.customValidators.isValidEventAmount = function(
  _: any,
  value: number | undefined | null,
  min: number
) {
  if (Number(value) === 0 || value === undefined || value === null) {
    return true;
  }
  return Number(value) > min;
};

Formsy.customValidators.isGreaterOrEqualToDate = function(_: any, value: Date, minDate: Date) {
  if (!(value instanceof Date)) {
    return false;
  }

  const clonedDate = new Date(value.getTime());
  const clonedMinDate = new Date(minDate.getTime());

  return clonedDate.setHours(0, 0, 0, 0) >= clonedMinDate.setHours(0, 0, 0, 0);
};

Formsy.customValidators.isValidAccountNumber = function(
  value: { account_number: string },
  _: any,
  currency: string
) {
  if ((window as any).Stripe) {
    // @ts-ignore - we're using an old version of Stripe that doesn't match the types
    return (window as any).Stripe.bankAccount.validateAccountNumber(value.account_number, currency);
  }
  return true;
};

Formsy.customValidators.isValidRoutingNumber = function(
  value: { routing_number: string },
  _: any,
  currency: string
) {
  if ((window as any).Stripe) {
    // @ts-ignore - we're using an old version of Stripe that doesn't match the types
    return (window as any).Stripe.bankAccount.validateRoutingNumber(value.routing_number, currency);
  }
  return true;
};

// CAUTION if you're using this in a form use isEmailWithSpaces or user may
// get confused by non-visible whitespace
Formsy.customValidators.isEmail = function(_: any, value: string) {
  return /^([\w\.%\+\-']+)@([\w\-]+\.)+([\w]{2,})$/i.test(value);
};

Formsy.customValidators.isEmailWithSpaces = function(values: {}, value: string) {
  return Formsy.customValidators.isEmail(values, value.trim());
};

Formsy.customValidators.couldPlausiblyBeANorthAmericanPhoneNumber = function(
  _: any,
  value: string
) {
  return !!value && /^\+?1?[- .]?\(?\d{3}\)?[- .]?\d{3}[- .]?\d{4}$/m.test(value);
};

Formsy.customValidators.isEmailOrPhone = (_: any, value: string) => {
  if (!value) {
    return 'Email address or phone number required';
  }
  if (value.indexOf('@') >= 0) {
    return Formsy.customValidators.isEmailWithSpaces(null, value) ? true : 'Invalid email address';
  } else {
    return Formsy.customValidators.couldPlausiblyBeANorthAmericanPhoneNumber(null, value)
      ? true
      : 'Invalid email address or phone number';
  }
};

Formsy.customValidators.isEmailOrPhoneOrFormIsEmpty = (
  values: { name?: string },
  value: string
) => {
  if (values.name || value) {
    return Formsy.customValidators.isEmailOrPhone(values, value);
  }
  return true;
};

Formsy.customValidators.isStrongEnoughPassword = (
  _values: any,
  _value: any,
  computedScore: number
) => {
  const minScore = 1;
  return computedScore >= minScore;
};

// We override Formsy's built-in isEmail with out own method that uses the same pattern used by API.
Formsy.addValidationRule('isEmail', Formsy.customValidators.isEmail);
Formsy.addValidationRule('isEmailWithSpaces', Formsy.customValidators.isEmailWithSpaces);
Formsy.addValidationRule('isEmailOrPhone', Formsy.customValidators.isEmailOrPhone);
Formsy.addValidationRule(
  'couldPlausiblyBeANorthAmericanPhoneNumber',
  Formsy.customValidators.couldPlausiblyBeANorthAmericanPhoneNumber
);
Formsy.addValidationRule('isValidAccountNumber', Formsy.customValidators.isValidAccountNumber);
Formsy.addValidationRule('isValidRoutingNumber', Formsy.customValidators.isValidRoutingNumber);
Formsy.addValidationRule('isValidEventAmount', Formsy.customValidators.isValidEventAmount);
Formsy.addValidationRule('isGreaterOrEqualToDate', Formsy.customValidators.isGreaterOrEqualToDate);
Formsy.addValidationRule('isRequired', Formsy.customValidators.isRequired);
Formsy.addValidationRule('isGreaterThan', Formsy.customValidators.isGreaterThan);
Formsy.addValidationRule('isLessThan', Formsy.customValidators.isLessThan);
Formsy.addValidationRule('isStrongEnoughPassword', Formsy.customValidators.isStrongEnoughPassword);

export default Formsy;
